import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Coupon } from './../coupon.model';
import { Component, OnInit, Inject } from '@angular/core';

@Component({
  selector: 'app-coupon-dialog',
  templateUrl: './coupon-dialog.component.html',
  styleUrls: ['./coupon-dialog.component.css']
})
export class CouponDialogComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<CouponDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public coupon: Coupon) { }

  ngOnInit() {
  }

  close(): void {
    this.dialogRef.close();
  }

}
